import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-document-new-folder-dialog',
    templateUrl: './document-new-folder-dialog.component.html',
    styleUrls: ['./document-new-folder-dialog.component.scss']
})
export class DocumentNewFolderDialogComponent {
    public isDisable = true;

    constructor(
        public dialogRef: MatDialogRef<DocumentNewFolderDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

    onChangeEvent(event) {
        this.isDisable = !(event && event.length >= this.data.folderNameMinLength && this.noWhitespaceValidator(event));
    }

    onKeydown(event) {
        if (event.key === 'Enter') {
            this.onCreate();
        }
    }

    onCreate() {
        this.dialogRef.close({ FolderName: this.data.name ? this.data.name : '' , Secured: this.data.Secure});
    }

    noWhitespaceValidator(control: string) {
        return !(control && control.replace(/\s/g, '').length < 1);
    }
}

export interface DialogData {
    name: string;
}
